import { type FC } from "react";

import { ContentHeader } from "../../../../shared/components";
import { HeaderSectionContainer } from "../../shared";

import { LensCards } from "./LensCards";
import { SelectTopLensesOption } from "./SelectTopLensesOption";
import { headerSectionContainerStyle } from "./TopLensesSection.styles";

export const TopLensesSection: FC = () => {
    return (
        <div>
            <HeaderSectionContainer className={headerSectionContainerStyle}>
                <ContentHeader title="Top Lenses" subtitle="The Lenses that Snapchatters engage with most." />
                <SelectTopLensesOption />
            </HeaderSectionContainer>
            <LensCards />
        </div>
    );
};
